import { FormEvent, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import ResumoDoPedido from "../../components/Carrinho/ResumoDoPedido";
import AplicarCupom, { CupomProps } from "../../components/Carrinho/AplicarCupom";
import Seta from "../../assets/SetaDireita.svg";
import styles from "./Carrinho.module.css";
import ProdutoItem from "../../components/Carrinho/Itens";
import { Produto } from "../../components/CardProduto/CardProduto";
import { useTranslation } from "react-i18next";
import api from "../../utils/axios/api";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";

interface Cart {
    id: string;
    product: Produto;
    amount: number;
}

interface Order {
    product: {
        id: string,
        quantity: number
    },
    amount: number
}

function Carrinho() {
    const navigate = useNavigate();
    const { changeNOrders, nOrders } = useCart()
    const [produtos, setProdutos] = useState<Produto[]>([]
    );
    const [carts, setCarts] = useState<Cart[]>([]);
    const [voucher, setVoucher] = useState<CupomProps>({
        name: "",
        discount: 0,
        valid: false,
    });
    const [larguraTela, setLarguraTela] = useState(window.innerWidth);
    const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
    const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
        window.innerWidth < 768
    );

    function handleWindowSizeChange() {
        setIsSmallScreen(window.innerWidth < 768);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        // Executar uma vez no início para garantir que o estado é atualizado com a largura da janela atual
        handleWindowSizeChange();

        return () => window.removeEventListener('resize', handleWindowSizeChange);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setLarguraTela(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //TODO: pegar do token do usuario logado

    const clientId = localStorage.getItem('clientId');
    useEffect(() => {

        const getClientCart = async () => {
            const newCarts = await api.get<Cart[]>(`/cart/client/${clientId}`);
            console.log(newCarts.data);
            setCarts(newCarts.data);
            setProdutos(
                newCarts.data.map((cart: any) => {
                    return {
                        ...cart.product,
                        quantidadePedido: cart.amount,
                    };
                })
            );
        };
        getClientCart();

    }, []);

    const removerItem = async (produtoId: string) => {
        const oldCart: any = carts.find(
            (cart: any) => cart.product.id === produtoId
        );
        try {
            await api.delete(`/cart/${oldCart.id}`);
            const newCarts = carts.filter(
                (cart: any) => cart.product.id !== produtoId
            );
            setCarts(newCarts);

            const novosProdutos = produtos.filter(
                (produto) => produto.id !== produtoId
            );
            setProdutos(novosProdutos);
            changeNOrders(nOrders - 1 >= 0 ? nOrders - 1 : 0)
        } catch (error) {
            console.error(error);
        }
    };

    const updateItem = async (produtoId: string, qtd: number) => {
        const oldCart: any = carts.find(
            (cart: any) => cart.product.id === produtoId
        );
        if(qtd > oldCart.product.quantity) {
            alert('Quantidade de item maior do que o estoque')
            return null
        }
        try {
            await api.put(`/cart/${oldCart.id}`, {
                clientId: localStorage.getItem("clientId"),
                productId: produtoId,
                amount: qtd,
                status: 'EM ABERTO'
            });
            const newCarts = carts.map(
                (cart: any) => {
                    if(cart.product.id === produtoId)
                        cart.amount = qtd
                    return cart
                }
            );
            setCarts(newCarts);
            const novosProdutos = produtos.map(
                (produto) => {
                    if(produto.id === produtoId) {
                        produto.quantidadePedido = qtd
                    }
                    return produto
                }
            );
            setProdutos(novosProdutos);
            return true
        } catch (error) {
            console.error(error);
            return null
        }
    };

    const handleSubmitShopping = async (event: FormEvent) => {
        event.preventDefault();

        const hasInvalidQuantity = carts.some((cart) => {
            const product = produtos.find((p) => p.id === cart.product.id);
            return product && cart.amount > product.quantity;
        });

        if (hasInvalidQuantity) {
            alert("A quantidade de um ou mais produtos excede o estoque disponível.");
            return;
        }

        try {
            navigate("/pagamento", {
                state: {
                    carts: carts.map(item => item.id),
                    voucher,
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const { t } = useTranslation();
    return (
        <div>
            <Header
                boxShadow
                mobileMenuActiveState={isMobileMenuVisible}
                toggleMobileMenu={setIsMobileMenuVisible}
                isSmallScreen={isSmallScreen}
                hamburgerIcon={false}
            />
            <div className={styles.caminho}>
                <div className={styles.item}>
                    <a href="/">{t("carrinho.paginaInicial")}</a>
                </div>
                <div className={styles.img_setacarrinho}>
                    <img className={styles.imagem_setacarrinho} src={Seta} alt="seta" />
                </div>
                <div className={styles.local}>
                    <span>{t("carrinho.carrinho")}</span>
                </div>
            </div>
            <div className={styles.titulo}>
                <p className={styles.titulocarrinho}>{t("carrinho.carrinho")}</p>
            </div>

            <div className={styles.carrinho_geral}>
                <form
                    className={styles.carrinho_container}
                    onSubmit={handleSubmitShopping}
                >
                    <ul className={styles.product_list}>
                        {produtos.map((produto) => (
                            <li key={produto.id} className={styles.product_item}>
                                <ProdutoItem
                                    produto={produto}
                                    onRemove={removerItem}
                                    onUpdate={updateItem}
                                    screenSize={larguraTela}
                                    amount={carts.find((cart) => cart.product.id === produto.id)?.amount ?? 0}
                                />
                            </li>
                        ))}
                    </ul>
                    <div className={styles.resumo}>
                        <p className={styles.tituloresumo}>{t("carrinho.resumo")}</p>
                        <p className={styles.descresumo}>{t("carrinho.descresumo")}</p>
                        <div className={styles.aplicarcupom}>
                            <AplicarCupom voucher={voucher} setVoucher={setVoucher} />
                        </div>
                        <ResumoDoPedido
                            produtos={produtos}
                            voucher={voucher}
                        />
                        <div className={styles.finalcarrinho}>
                            <button type="submit" className={styles.conc}>
                                <strong>{t("carrinho.concluir")}</strong>
                            </button>
                            <a className={styles.continuar} href="/">
                                {t("carrinho.continuar")}
                            </a>
                        </div>
                    </div>
                </form>
            </div>
            {!isSmallScreen && (<Footer />)}
        </div>
    );
}

export default Carrinho;
